import { defineMessages } from 'react-intl';

export const locale = defineMessages({
  htmlTitle: {
    id: 'add-ons.htmlTitle',
    description: 'Title to the page',
    defaultMessage: 'Add-ons - Universe'
  },
  title: {
    id: 'add-ons.title',
    description: 'Title to the page',
    defaultMessage: 'Add-ons'
  },
  description: {
    id: 'add-ons.description',
    description: 'Information about add-ons',
    defaultMessage:
      'Offer additional items to your ticket buyers during checkout that can be picked up or redeemed at your event.'
  },
  orders: {
    id: 'add-ons.orders',
    defaultMessage: 'Orders'
  },
  bannerHeader: {
    id: 'add-ons.bannerHeader',
    defaultMessage: 'New updates and enhancements'
  },
  bannerPoint_1: {
    id: 'add-ons.bannerPoint_1',
    defaultMessage: 'You can make your add-on available for specific ticket types on selected events.'
  },
  bannerPoint_2: {
    id: 'add-ons.bannerPoint_2',
    defaultMessage: 'You can limit the quantity of add-ons available per timeslot.'
  },
  bannerPoint_3: {
    id: 'add-ons.bannerPoint_3',
    defaultMessage: 'You can restrict your add-ons’ availability to specific times.'
  },
  cancelationModalHeader: {
    id: 'add-ons.cancelationModalHeader',
    description: 'Cancel changes',
    defaultMessage: 'Cancel changes',
  },
  cancelationModalContent: {
    id: 'add-ons.cancelationModalContent',
    description: 'Cancel modal content',
    defaultMessage: 'Are you sure you want to cancel these changes to your add-on? By clicking Cancel changes,' +
      'all changes entered will not be saved. This action cannot be undone.',
  },
  cancelationModalClose: {
    id: 'add-ons.cancelationModalClose',
    description: 'Cancel changes',
    defaultMessage: 'Cancel changes',
  },
  cancelationModalKeep: {
    id: 'add-ons.cancelationModalKeep',
    description: 'Keep changes',
    defaultMessage: 'Keep changes',
  }
});
